import { render, staticRenderFns } from "./UICloseButton.vue?vue&type=template&id=14e7c154&"
import script from "./UICloseButton.vue?vue&type=script&lang=js&"
export * from "./UICloseButton.vue?vue&type=script&lang=js&"
import style0 from "./UICloseButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports